import Layout from '@/layout'

const asyncBiddingRoutes = {
  path: '/purchase/bidding',
  component: Layout,
  redirect: 'noRedirect',
  name: '竞价管理',
  funcPerms: '',
  meta: {
    title: '竞价管理',
    icon: '',
    affix: false,
    noCache: false
  },
  children: [
    {
      path: '/purchase/bidding/apply/purchase_12',
      component: () => import('@/views/purchase/purchaseBidding/myProcess/index.vue'),
      name: '我的竞价申请',
      funcPerms: 'purchase:bidding:apply:my:process',
      meta: {
        title: '我的竞价申请',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/bidding/pass/purchase_12',
      component: () => import('@/views/purchase/purchaseBidding/todo/index.vue'),
      name: '我未审批的竞价',
      funcPerms: 'purchase:bidding:apply:my:todo',
      meta: {
        title: '我未审批的竞价',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/bidding/my/finished/purchase_12',
      component: () => import('@/views/purchase/purchaseBidding/finished/index.vue'),
      name: '我已审批的竞价',
      funcPerms: 'purchase:bidding:apply:my:finished',
      meta: {
        title: '我已审批的竞价',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/bidding/list',
      component: () => import('@/views/purchase/purchaseBidding/list/index.vue'),
      name: '竞价列表',
      funcPerms: 'purchase:bidding:apply:list:all',
      meta: {
        title: '竞价列表',
        icon: '',
        affix: false,
        noCache: false
      }
    }
  ]
}

export default asyncBiddingRoutes
